import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Container, Empty } from '@easymoving/ui';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Container className="py-10 md:py-14">
      <Empty
        title={t('notFound.title')}
        body={t('notFound.body')}
        action={
          <Button asChild>
            <Link to="/app">{t('notFound.home')}</Link>
          </Button>
        }
      />
    </Container>
  );
}
